/* Independent editor, cart toggle, and optional presentation enhancements. */
(() => {
  const seen=new Set();
  async function toggle(input,preselected=false) {
    if(input.disabled||!window.icLibrary)return;
    const container=input.closest('[data-ic-block]');input.disabled=true;
    try {
      if(input.checked||preselected)await window.icLibrary.cartRequest('cart/add.js',{items:[{id:Number(input.dataset.icCartToggle),quantity:1}]},container,true);
      else await window.icLibrary.cartRequest('cart/change.js',{id:input.dataset.icCartKey||Number(input.dataset.icCartToggle),quantity:0},container,true);
    }catch(error){input.checked=!input.checked;const status=container?.querySelector('[data-ic-status]');if(status){status.hidden=false;status.textContent=error.message;}}
    finally{if(input.isConnected)input.disabled=false;}
  }
  document.addEventListener('change',e=>{if(e.target.matches('[data-ic-cart-toggle]'))toggle(e.target);});
  function init(scope=document){
    scope.querySelectorAll('[data-ic-preselected="true"]:not(:checked):not(:disabled)').forEach(input=>{
      const key=input.dataset.icCartToggle;if(seen.has(key)||!document.querySelector('cart-drawer:not(.is-empty)'))return;
      seen.add(key);toggle(input,true);
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('fc:cart-updated',()=>init());
  const observer=new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1&&node.querySelector)init(node);});
  document.addEventListener('DOMContentLoaded',()=>observer.observe(document.body,{childList:true,subtree:true}));
})();
